/**
 * Calculate percentage off between two prices
 */
export const calculatedPercentageOff = (originalPrice: number, salePrice: number): number => {
  return Math.round(((originalPrice - salePrice) / originalPrice) * 100);
};
